<template>
  <c-footer :fixed="false">
    <div>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }} Nanome</span>
    </div>
  </c-footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
